import AlRsvpSelectorController from './controller';
import templateUrl from './component.tpl.html';

angular.module('festzelt-os.modules.rsvps')
.component(
    'alRsvpSelector',
    {
        controller: AlRsvpSelectorController,
        controllerAs: 'vm',
        bindings: {
            scopedGuestlists: '<',
            onGuestlistSelect: '&',
            onRsvpSelect: '&'
        },
        templateUrl
    }
)



// WEBPACK FOOTER //
// ./src/app/modules/rsvps/components/al-rsvp-selector/component.js